import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslateService {
  private readonly languageStorageKey = "ALTOMATE_LANGUAGE_KEY";

  constructor(private translocoService: TranslocoService) {

    // this.currentLang = this.translocoService.getDefaultLang();
    // const availableLangs = this.translocoService.getAvailableLangs();
    // // Check if languages are provided as strings or objects, and extract accordingly
    // if (Array.isArray(availableLangs) && typeof availableLangs[0] === 'string') {
    //   this.languages = availableLangs as string[];
    // } else {
    //   this.languages = (availableLangs as { id: string; label: string }[]).map(lang => lang.id);
    // }
  }

  // Get current active language
  getCurrentLang(): string {
    return this.translocoService.getActiveLang();
  }

  getStoredLanguage(): string | null {
    try {
      if (typeof localStorage === "undefined") return null;
      const value = localStorage.getItem(this.languageStorageKey);
      return value || null;
    } catch {
      return null;
    }
  }

  // Change language programmatically
  setLanguage(lang: string): void {
    this.translocoService.setActiveLang(lang);
    try {
      if (typeof localStorage === "undefined") return;
      localStorage.setItem(this.languageStorageKey, lang);
    } catch {
      // ignore
    }
  }

  // Translate a key programmatically
  translate(key: string, params?: Record<string, any>): string {
    return this.translocoService.translate(key, params);
  }

  // Asynchronously translate a key
  asyncTranslate(key: string, params?: Record<string, any>): Promise<string> {
    return this.translocoService.selectTranslate(key, params).toPromise();
  }

  onLanguageChange(): Observable<string> {
    return this.translocoService.langChanges$;
  }

}
